import { TOUR_ID, ONBOARDING_TOUR_ID, ONBOARDING_TOUR_SOURCE } from '../constants/URL';
import { getLinkedTourState } from './linkedTourUtils';
import { getQueryParam } from './urlUtils';
export { ONBOARDING_TOUR_SOURCE } from '../constants/URL';

// Note: A lot of these values are de facto also 'via' query param values
export const TourSource = {
  UserGuide: 'user-guide',
  CommerceHubUserGuide: 'commerce-hub-user-guide',
  Import: 'import',
  OnboardingPlanUi: 'onboarding-plan-ui',
  MarketingSignup: 'marketing-signup',
  StarterOnboardingCampaign: 'starter-onboarding-campaign',
  CampaignAssistant: 'campaign-assistant',
  OnboardingTourGuide: 'onboarding-tour-guide',
  OnboardingToursGuide: 'onboarding-tours-guide',
  SalesWorkspaceOnboarding: 'sales-workspace-onboarding',
  GrowthCrmSetup: 'growth-crm-setup',
  OnboardingSurfaceUi: 'onboarding-surface-ui'
};
export const VALID_TOUR_SOURCES = new Set(Object.values(TourSource));
/**
 * Adds the tour source query parameter to the url
 * @param options - options of tour source util
 * @param options.url - url to add tour source to
 * @param options.tourSource - tour source
 * @param options.skipTourCheck - option to skip tour id check on url and always add tour source if value is true
 * @returns The url with the tour source query parameter added
 */
export const addSourceToTourUrl = ({
  url,
  tourSource,
  skipTourCheck = false
}) => {
  const [pathname, queryString] = url.split('?');
  const searchParams = new URLSearchParams(queryString);
  if (skipTourCheck || searchParams.has(TOUR_ID) || searchParams.has(ONBOARDING_TOUR_ID)) {
    searchParams.set(ONBOARDING_TOUR_SOURCE, tourSource);
    return `${pathname}?${searchParams.toString()}`;
  }
  return url;
};

/**
 * Retrieves the tour source from session storage (next tour) or query parameters
 * @returns The detected tour source if valid, undefined otherwise
 */
export const getTourSource = () => {
  const linkedTourState = getLinkedTourState();
  const detectedTourSource = (linkedTourState === null || linkedTourState === void 0 ? void 0 : linkedTourState.tourSource) || getQueryParam(ONBOARDING_TOUR_SOURCE) || getQueryParam('via');
  return detectedTourSource && VALID_TOUR_SOURCES.has(detectedTourSource) ? detectedTourSource : undefined;
};